import React from 'react';
import 'twin.macro';
import { VacancySalaryFields } from 'types/vacancyTypes';
import { formatSalaryDisplay } from 'utils/salaryHelpers';

interface SalaryLineProps {
  salary: VacancySalaryFields;
  showEmptyState?: boolean;
}

const SalaryLine: React.FC<SalaryLineProps> = ({
  salary,
  showEmptyState = false,
}) => {
  const salaryText = formatSalaryDisplay(
    salary,
    salary.salary_metadata?.display
  );
  const salaryLabel = salary.salary_metadata?.display?.label ?? 'Salary';

  if (!salaryText && !showEmptyState) return null;

  return (
    <div
      tw="mb-4 rounded border border-dashed border-gray-300 bg-white/70 px-4 py-3 text-sm"
      data-testid="vacancy-preview-salary-line"
    >
      {salaryText ? (
        <>
          <span tw="font-semibold text-gray-900">{salaryLabel}: </span>
          <span tw="text-gray-800">{salaryText}</span>
        </>
      ) : (
        <span tw="text-gray-400">Salary line will appear here.</span>
      )}
    </div>
  );
};

export default SalaryLine;
